// extracted by mini-css-extract-plugin
export default {"tocProfile":"GlobalToc__tocProfile___1PzHc","userProfileSidebar":"GlobalToc__userProfileSidebar___1rYGL","toc":"GlobalToc__toc___pY_xZ"};